import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { useRouter } from 'next/router';
import { useContext } from 'react';

import Button from '@/contents/General/Button';
import Icon from '@/contents/General/Icon';
import { Board } from '@/contents/General/Panels';
import Stack from '@/contents/General/Stack';
import Typography from '@/contents/General/Typography';
import { GlobalContext } from '@/contents/hooks/state';
import theme from '@/styles/theme';

const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

type Props = {
  title: string;
  description: string;
  routerPath?: string;
};

const Break = ({ title, description, routerPath }: Props) => {
  const router = useRouter();
  const { dialogStatus, setDialogStatus, isEdit, setIsEdit, setIsShowForm } =
    useContext(GlobalContext);

  const allowBack: () => void = dialogStatus.props.allowBack || '';
  const cancel: () => void = dialogStatus.props.cancel || '';

  const keepEdit = () => {
    setDialogStatus({ ...dialogStatus, open: false });
  };

  const nextPage = () => {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    allowBack && allowBack();
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    cancel && cancel();
    setIsEdit(false);
    setDialogStatus({ ...dialogStatus, open: false });
    if (routerPath) {
      if (routerPath.match(/contact/)) {
        setIsShowForm(false);
      } else {
        router.push(routerPath);
      }
    } else {
      router.back();
    }
  };

  return (
    <>
      <Container>
        <Board sx={{ padding: theme.spacing(3) }}>
          <Typography
            fontSize={16}
            fontWeight={700}
            paddingTop={2}
            paddingBottom={2}
          >
            {title}
          </Typography>
          <Typography fontSize={14} paddingBottom={2}>
            {description}
          </Typography>
          <Stack column center space={3} padding={2}>
            <Button
              buttonSize="md"
              onClick={nextPage}
              color="white"
              sx={{
                width: '246px',
                border: `solid 1px ${theme.palette.primary.main}`,
              }}
            >
              このページから離れる
            </Button>
            <Stack center onClick={keepEdit} sx={{ cursor: 'pointer' }}>
              <Icon iconType="arrow-right" color="parimary" />
              <Typography fontSize={14} fontWeight={700} color="primary">
                このページにとどまる
              </Typography>
            </Stack>
          </Stack>
        </Board>
      </Container>
    </>
  );
};

export default Break;
